import { State } from '../state';

export const AssetSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    assets: (state: State) => state.Asset,
};
